const SESSION_KEY = 'auth_session';
const SESSION_DURATION = 3 * 60 * 60 * 1000; // 3 hours in milliseconds
// const SESSION_DURATION = 3  * 60 * 1000; // 3 hours in milliseconds

export const sessionManager = {
  // Create session without token
  createSession: (userData) => {
    const sessionData = {
      user: userData,
      loginTime: Date.now(),
      expiresAt: Date.now() + SESSION_DURATION,
      sessionId: `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
    };
    localStorage.setItem(SESSION_KEY, JSON.stringify(sessionData));
    
    // Setup auto logout timer
    sessionManager.setupAutoLogout();
  },

  // Get current session
  getSession: () => {
    const sessionStr = localStorage.getItem(SESSION_KEY);
    if (!sessionStr) return null;
    
    try {
      const session = JSON.parse(sessionStr);
      return session;
    } catch (error) {
      console.error('Failed to parse session:', error);
      return null;
    }
  },

  // Check if session is valid
  isValidSession: () => {
    const session = sessionManager.getSession();
    if (!session) return false;
    
    const now = Date.now();
    // Check if session has expired
    const isExpired = now >= session.expiresAt;
    
    // Also check if essential user data exists
    const hasUserData = session.user && session.user.email;
    
    return !isExpired && hasUserData;
  },

  // Get user data
  getUser: () => {
    const session = sessionManager.getSession();
    return session ? session.user : null;
  },

  // Clear session
  clearSession: () => {
    localStorage.removeItem(SESSION_KEY);
    sessionManager.clearAutoLogout();
  },

  // Get remaining session time in milliseconds
  getRemainingTime: () => {
    const session = sessionManager.getSession();
    if (!session) return 0;
    
    const now = Date.now();
    return Math.max(0, session.expiresAt - now);
  },

  // Format remaining time for display
  getFormattedRemainingTime: () => {
    const remainingMs = sessionManager.getRemainingTime();
    if (remainingMs <= 0) return 'Expired';
    
    const hours = Math.floor(remainingMs / (1000 * 60 * 60));
    const minutes = Math.floor((remainingMs % (1000 * 60 * 60)) / (1000 * 60));
    
    return `${hours}h ${minutes}m`;
  },

  // Auto logout timer
  logoutTimer: null,

  setupAutoLogout: () => {
    // Clear existing timer
    sessionManager.clearAutoLogout();
    
    const remainingTime = sessionManager.getRemainingTime();
    
    if (remainingTime > 0) {
      sessionManager.logoutTimer = setTimeout(() => {
        sessionManager.clearSession();
        // Dispatch event to notify app about session expiration
        window.dispatchEvent(new Event('session-expired'));
        console.log('Session expired automatically after 3 hours');
      }, remainingTime);
    }
  },

  clearAutoLogout: () => {
    if (sessionManager.logoutTimer) {
      clearTimeout(sessionManager.logoutTimer);
      sessionManager.logoutTimer = null;
    }
  },

  // Refresh session (extend expiration)
  refreshSession: () => {
    const session = sessionManager.getSession();
    if (session) {
      session.loginTime = Date.now();
      session.expiresAt = Date.now() + SESSION_DURATION;
      localStorage.setItem(SESSION_KEY, JSON.stringify(session));
      sessionManager.setupAutoLogout();
      return true;
    }
    return false;
  },

  // Check session and refresh if valid
  validateAndRefreshSession: () => {
    if (sessionManager.isValidSession()) {
      return sessionManager.refreshSession();
    }
    return false;
  }
};